"use client";

import type { ReactNode } from "react";

import type { MarkdownDocument } from "@/lib/content/markdown";

import { MarkdownContent } from "./markdown-content";

type MarkdownInlineContentProps = {
  document?: MarkdownDocument | null;
  className?: string;
  emptyState?: ReactNode;
};

export function MarkdownInlineContent(props: MarkdownInlineContentProps) {
  return <MarkdownContent {...props} variant="inline" />;
}
